var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { convertToCSSValue, getGeometryStyle } from '../../helpers/styles';
import { isTrue } from '../../helpers/utils';
import ListItem from './Item';
var StyledList = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: ", ";\n  ", "\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  ", "\n"], ["\n  box-sizing: ", ";\n  ", "\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  ",
    "\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.boxSizing;
}, function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.list.borderColor.bottom;
}, function (_a) {
    var attributes = _a.attributes;
    var wordWrap = attributes.wordWrap, horizontalScrollBarPolicy = attributes.horizontalScrollBarPolicy, verticalScrollBarPolicy = attributes.verticalScrollBarPolicy, maximumSize = attributes.maximumSize, minimumSize = attributes.minimumSize;
    return "\n            overflow-x: " + (horizontalScrollBarPolicy === 'ScrollBarAlwaysOn'
        ? 'scroll'
        : 'hidden') + ";\n            overflow-y: " + (verticalScrollBarPolicy === 'ScrollBarAlwaysOn'
        ? 'scroll'
        : 'hidden') + ";\n            max-height: " + (maximumSize ? convertToCSSValue(maximumSize.height) : '') + ";\n            max-width: " + (maximumSize ? convertToCSSValue(maximumSize.width) : '') + ";\n            min-height: " + (minimumSize ? convertToCSSValue(minimumSize.height) : '') + ";\n            min-width: " + (minimumSize ? convertToCSSValue(minimumSize.width) : '') + ";\n\n            div {\n                white-space: " + (isTrue(wordWrap) ? 'normal' : 'nowrap') + ";\n            };\n        ";
});
var List = function (props) {
    var form = props.form, type = props.type, _a = props.dataItems, dataItems = _a === void 0 ? {} : _a, identifier = props.identifier, getWidget = props.getWidget, system = props.system, location = props.location, restProps = __rest(props, ["form", "type", "dataItems", "identifier", "getWidget", "system", "location"]), dataItemsInList = dataItems[identifier] || [];
    console.log('[List] ', props);
    return (React.createElement(StyledList, __assign({}, restProps), dataItemsInList.map(function (_a) {
        var key = _a.key, value = _a.value;
        return (React.createElement(ListItem, { key: key, item: value, getWidget: getWidget, system: system }));
    })));
};
export default withRouter(List);
var templateObject_1;
//# sourceMappingURL=index.js.map